import {
  BASE_URL_OPTION_KEY,
  MODULES_OPTION_KEY,
  CUSTOMER_LIST_ID_OPTION_KEY,
  DISPLAY_NAME_OPTION_KEY,
  TAGS_OPTION_KEY,
} from 'flow/service/actionOptions/constants';
import { CUSTOM_LIST_COLUMNS_OPTION_KEY } from 'flow/service/actions/services/customLists/constants';

export const SERVICE_FAILURE_DEFAULT_LABELS = {
  EXIT_WORKFLOW: 'Exit Workflow',
  RUN_SERVICE: 'Run Service',
  DO_NOT_RUN_SERVICE: 'Do Not Run Service',
};

export const SERVICE_FAILURE_DEFAULT_VALUES = {
  [SERVICE_FAILURE_DEFAULT_LABELS.EXIT_WORKFLOW]: null,
  [SERVICE_FAILURE_DEFAULT_LABELS.RUN_SERVICE]: true,
  [SERVICE_FAILURE_DEFAULT_LABELS.DO_NOT_RUN_SERVICE]: false,
};

export const SERVICE_OPTION_TEXTFIELD_LABEL_MAP = new Map([
  [BASE_URL_OPTION_KEY, 'Base Url'],
  [MODULES_OPTION_KEY, 'Modules'],
]);

// Options to exclude from additional options section:
export const RESERVED_KEYS = [
  CUSTOMER_LIST_ID_OPTION_KEY,
  CUSTOM_LIST_COLUMNS_OPTION_KEY,
  DISPLAY_NAME_OPTION_KEY,
  TAGS_OPTION_KEY,
];
